module.exports = __webpack_public_path__ + "static/media/logo.560c3ca3.png";